import React, { FC, MouseEvent, ReactNode } from "react";
import classNames from "classnames";
import { handleMouseUpByBlurring } from "../../../utils/focus";

export enum LinkIconAnimation {
  SlideStart = "slide-start",
  SlideEnd = "slide-end",
}

interface ILinkProps {
  href?: string;
  rel?: string;
  target?: string;
  className?: string;
  onClick?: (event?: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  iconStart?: ReactNode;
  iconEnd?: ReactNode;
  iconAnimation?: LinkIconAnimation;
  id?: string;
}

const Link: FC<ILinkProps> = ({
  href,
  rel,
  onClick,
  target,
  children,
  className,
  iconStart,
  iconEnd,
  iconAnimation,
  id,
}) => {
  const isExternal = href?.includes("://") && href[0] !== "#";
  const defaultRel = isExternal ? "noopener noreferrer" : undefined;
  const defaultTarget = isExternal ? "_blank" : undefined;
  const linkRel = rel ?? defaultRel;
  const linkTarget = target ?? defaultTarget;
  const iconClass = classNames("kl-link__icon", { [`kl-link__icon--${iconAnimation}`]: iconAnimation });

  // @NOTE (HamishMW, 02/10/2020) <a> tags without an href aren't tabbable in the accessibility tree,
  // so we change the element to a button when provided an onClick and no href
  const Component = !!onClick && !href ? "button" : "a";

  return (
    <Component
      className={classNames("kl-link", className)}
      href={href}
      rel={linkRel}
      target={linkTarget}
      onClick={onClick}
      onMouseUp={handleMouseUpByBlurring}
      id={id}
    >
      {!!iconStart && <span className={classNames(iconClass, "kl-link__icon--start")}>{iconStart}</span>}
      <span className="kl-link__text">{children}</span>
      {!!iconEnd && <span className={classNames(iconClass, "kl-link__icon--end")}>{iconEnd}</span>}
    </Component>
  );
};

export default Link;
